import Blog from  '../img/blogs/Blog.png';
import dev from  '../img/blogs/dev.png';
import tata from  '../img/blogs/tata.png';
import tatat from "../img/blogs/tatat.png";

const blogs = [
  {
    id: 1,
    title: "What is React.Js ?",
    date: 29,
    month: "16th April,2022",
    src: "https://cyberspace33.blogspot.com/2022/05/what-is-react-js.html",
    image: Blog,
  },
  {
    id: 2,
    title: "An Engineer's Journey",
    date: "03",
    src: "#",
    month: "Oct 2021",
    image: dev,
  },
  {
    id: 3,
    title: "Web 3",
    date: "03",
    src: "#",
    month: "Oct 2021",
    image: tata,
  },

  {
    id: 4,
    title: "Street Code Project",
    date: "03",
    src: "#",
    month: "Oct 2021",
    image: tatat,
  },
];

export default blogs;